/*
 * @Description: 付款信息修改
 * @Author: 杨志航
 * @Date: 2026-03-31 09:12:15
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Select,
  message,
  DatePicker,
  Upload,
  Icon,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { uploadDragger } from '@/utils/uploadDragger'
import { allTrim, filterParams } from '@/utils'
import moment from 'moment'

const FormItem = Form.Item
const { Dragger } = Upload
const dateFormat = 'YYYY-MM-DD'
let draggerObj = {}

const EditPayment = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const { setEditVisible, getList, editData } = props
  const [saveLoading, setSaveLoading] = useState(false)
  const [payAccounts, setPayAccounts] = useState([])

  useEffect(() => {
    draggerObj = uploadDragger({
      accept: '.jpg, .jpeg, .png, .pdf',
      limitNum: 1,
      limitSize: 5,
    })
    const { certificate, payTime, payAccountNo, payBank, companyId } = editData
    if (certificate && certificate.length > 0) {
      setFieldsValue({
        certificate: certificate.map(item => {
          const { name, url } = item
          return {
            uid: '-1',
            name,
            status: 'done',
            url,
          }
        }),
      })
    }
    if (payTime) {
      setFieldsValue({
        payTime: moment(payTime, dateFormat),
      })
    }
    api.getCorporateAccountlist({ limit: 99999, corpId: companyId }).then(data => {
      setPayAccounts(Array.isArray(data.list) ? data.list : [])
      if (payAccountNo) {
        setFieldsValue({
          paymentNumber: `${payAccountNo}|${payBank}`,
        })
      }
    }).catch(err => console.log(err))
  }, [])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        const { id } = editData
        vals = filterParams(vals)
        vals.payTime = vals.payTime.format(dateFormat)
        vals.certificate = vals.certificate.map(item => {
          const { name, url } = item
          return {
            name,
            url,
          }
        })
        const [payAccountNo, payBank] = vals.paymentNumber.split('|')
        vals.payAccountNo = payAccountNo
        vals.payBank = payBank
        delete vals.paymentNumber
        vals = {
          id,
          ...vals,
        }
        setSaveLoading(true)
        api.editRefundOrderPayment(vals).then(() => {
          setSaveLoading(false)
          setEditVisible(false)
          message.success('修改成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="业务编号">
          {editData.number || '--'}
        </FormItem>
        <FormItem label="退款金额">
          {editData.amount || '--'}
        </FormItem>
        <FormItem label="公司主体">
          {editData.companyName || '--'}
        </FormItem>
        <FormItem label="收款单位">
          {editData.client || '--'}
        </FormItem>
        <FormItem label="收款开户行">
          {editData.bankName || '--'}
        </FormItem>
        <FormItem label="收款账号">
          {editData.bankAccount || '--'}
        </FormItem>
        <FormItem label="银行支付日期">
          {getFieldDecorator('payTime', {
            initialValue: moment(new Date(), dateFormat),
            rules: [{ required: true, message: '请选择银行支付日期' }]
          })(
            <DatePicker 
              placeholder="请选择" 
              format={dateFormat}
              style={{ width: '100%'}}
            />
          )}
        </FormItem>
        <FormItem label='付款账号'>
          {getFieldDecorator('paymentNumber', {
            rules: [{ required: true, message: '请选择付款账号' }],
          })(
            <Select
              placeholder='请选择'
              dropdownMatchSelectWidth={false}
              showSearch
              className='pay-account-select'
              optionFilterProp='label'
              allowClear
            >
              {payAccounts.map((item) => (
                <Select.Option
                  key={item.id}
                  value={`${item.accountNo}|${item.bank}`}
                  label={`${item.accountNo}\n${item.bank}`}
                >
                  <div>
                    <div>{item.accountNo}</div>
                    <div>{item.bank}</div>
                  </div>
                </Select.Option>
              ))}
            </Select>
          )}
        </FormItem>
        <Form.Item label="付款凭证">
          {getFieldDecorator('certificate', {
            valuePropName: 'fileList',
            getValueFromEvent: draggerObj.normFile,
          })(
            <Dragger {...draggerObj}>
              <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
              </p>
              <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
              <p className="ant-upload-hint">
                支持扩展名：.jpg、.jpeg、.png、.pdf<br/>单个文件大小不超过5M。
              </p>
            </Dragger>
          )}
        </Form.Item>
        <BtnGroup onCancel={() => setEditVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(EditPayment)
